import { createEmitter } from "ts_utils";
import { SongDO } from "../data/SongDO";
import { Templates } from "../ui/Templates";
import { songItem } from "../ui/templates/songMenuTemplates";

export abstract class AbstractPanelItem {
	
	public index:number;
	
	public ui:HTMLDivElement;
	
	public static get click() { return AbstractPanelItem._clickEmitter.event; }
	private static _clickEmitter = createEmitter<AbstractPanelItem>();
	
	constructor(){
		this._init();
	}
	
	private _init():void {
		this._createUi();
	}
	
	/**override in sub classes to create custom PanelItem design*/
	private _createUi():void {
		this.ui = Templates.createDiv(this.getUiTemplate());
		this.ui.addEventListener("click", this._onUiClick);
	}
	
	private _onUiClick = (e:MouseEvent) => {
		AbstractPanelItem._clickEmitter.emit(this);
	}
	
	abstract getUiTemplate():string;
}


export class SongPanelItem extends AbstractPanelItem {
	public get songDO():SongDO { return this._songDO; }
	private _songDO:SongDO;
	
	constructor(songDO:SongDO){
		super();
		this._songDO = songDO;
		this._draw();
	}
	
	public override getUiTemplate():string {
		return songItem;
	}
	
	public updateAssessmentScore(score:number, studentLoggedIn:boolean):void {
		let scoreContainer = this.ui.querySelector(
			".m-songItem-scoreContainer") as HTMLDivElement;
		if (!studentLoggedIn){
			scoreContainer.style.display = "none";
		}
		else {
			scoreContainer.style.display = "flex";
			let scoreDiv = this.ui.querySelector('.m-songItem-scoreDiv') as
				HTMLDivElement;
			let text = (score == null)? "???" : `${score}%`;
			scoreDiv.innerHTML = text;
		}
		
	}
	
	private _draw():void {
		
		this.updateAssessmentScore(null, false);
		
		//title
		let titleDiv = this.ui.querySelector('.m-title') as HTMLDivElement;
		let titleText = this._songDO.title?? '';
		
		let a = document.createElement("a");
		a.href = `./?id=${this._songDO.libId}`;
		a.innerHTML = titleText;
		titleDiv.append(a);
		a.addEventListener("click", (e) => {
			e.preventDefault();
		});
	}
}